<div class="number-stats" [ngClass]="cardClass">
<div class="card stat-card" [ngClass]="cardClass">
  <div class="card-content">
    <div class="card-title" [innerHTML]="formattedTitle"></div>
    <div *ngIf="subtitle" class="card-subtitle">{{ subtitle }}</div>
    <div class="card-value-or-error">
      <div *ngIf="!hasError" class="card-value">{{ stat }}</div>
      <mat-icon *ngIf="hasError" class="stat-error-icon">error_outline</mat-icon>
    </div>
    <div *ngIf="note" class="card-note">{{ note }}</div>
    <div *ngIf="badges.length" class="badge-strip">
      <div class="stat-badge" *ngFor="let badge of badges">
        <span class="badge-label">{{ badge.label }}</span>
        <span class="badge-value">{{ badge.value }}</span>
      </div>
    </div>
  </div>
</div>
</div>
